Ext.define('SA.data.Ranking.DataMap', {
    constructor(cfg) {
        Object.assign(this, cfg);

        this.data = {locationSeries: [], name: []};
        this.callbacks = new SA.data.CallbackSet();
        this.derivedAttributes = {};
        this.numberOfAvailableResultsUpTo10001 = null;
    },

    createQueryConfig(attributes) {
        var location = this.location,
            size = this.size,
            sort = this.sort,
            geographicUnit = this.geographicUnit,
            sorting = [sort],
            derivedAttributes = this.derivedAttributes,
            where = [
                'and',
                ['=', 'geographicUnit', geographicUnit],
                ['in', 'geographicRelease'].concat(this.geographicReleases)
            ];

        if (location.type === 'radius') {
            where.push(['radius', geographicUnit, location.radius, location.locationSeries[0]]);
        }
        else {
            where.push(['within'].concat(location.locationSeries));
        }

        if (sort[1] !== 'name') {
            sorting.push(['asc', 'name']);
        }

        return {
            fields: attributes.map(attribute => derivedAttributes[attribute] || attribute),
            filter: this.filter,
            limit: this.hasRetrievedNumberOfAvailableResultsUpTo10001() ? size : 10001,
            sort: sorting,
            type: 'locations',
            where
        };
    },

    destroy() {
        this.run = this.ensure = Ext.emptyFn;
        this.callbacks.clear();
    },

    ensure(cfg) {
        var map = this.data,
            attributes = cfg.attributes,
            derived = cfg.derivedAttributes,
            derivedMap = this.derivedAttributes,
            callbacks = this.callbacks,
            missingAttributes = [];

        for (let attribute in derived) {
            let json = JSON.stringify(derived[attribute]);

            if (json !== JSON.stringify(derivedMap[attribute])) {
                map[attribute] = [];

                derivedMap[attribute] = JSON.parse(json);
            }
        }

        attributes.forEach(attribute => {
            if (!map[attribute]) {
                map[attribute] = [];
            }
        });

        if (this.hasNoAvailableResults() || cfg.run === false) {
            return;
        }

        if (this.activeQuery) {
            callbacks.add(cfg.fn, cfg.scope);
            return;
        }

        for (let attribute in map) {
            if (!map[attribute].length) {
                missingAttributes.push(attribute);
            }
        }

        if (missingAttributes.length) {
            callbacks.add(cfg.fn, cfg.scope);

            this.run(missingAttributes);
        }
    },

    getData() {
        return this.data;
    },

    getNumberOfAvailableResultsUpTo10001() {
        return this.numberOfAvailableResultsUpTo10001 || 0;
    },

    hasNoAvailableResults() {
        return this.hasRetrievedNumberOfAvailableResultsUpTo10001() && this.getNumberOfAvailableResultsUpTo10001() === 0;
    },

    hasRetrievedNumberOfAvailableResultsUpTo10001() {
        return this.numberOfAvailableResultsUpTo10001 !== null;
    },

    removeAttribute(attribute) {
        delete this.data[attribute];
        delete this.derivedAttributes[attribute];
    },

    run(attributes) {
        var query = this.createQueryConfig(attributes);

        this.activeQuery = query = SA.data.Query.from(query);

        query.addFailure(() => {
            this.activeQuery = null;
        });

        query.addSuccess(rows => {
            this.numberOfAvailableResultsUpTo10001 = this.numberOfAvailableResultsUpTo10001 || rows.length;

            var map = this.data,
                rowIndex = 0,
                rowCount = Math.min(rows.length, this.size),
                row;

            this.activeQuery = null;

            for ( ; rowIndex < rowCount ; ++rowIndex) {
                row = rows[rowIndex];

                attributes.forEach((attribute) => {
                    var list = map[attribute];

                    if (list) {
                        list[rowIndex] = row[attribute];
                    }
                });
            }

            this.callbacks.run();
        });

        query.run();
    },

    setSize(size) {
        var data = this.data,
            oldSize = this.size;

        if (size === oldSize) {
            return;
        }

        this.size = size;

        if (size < oldSize) {
            for (let attribute in data) {
                let list = data[attribute];

                if (list.length > size) {
                    list.length = size;
                }
            }
        }
        else if (oldSize < this.getNumberOfAvailableResultsUpTo10001()) {
            let list = [];

            for (let attribute in data) {
                list.push(attribute);
            }

            this.run(list);
        }
    }
});